/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdSchoolEducations200,
  GetApiV1PersonIdSchoolEducations401,
  GetApiV1PersonIdSchoolEducations404,
  GetApiV1PersonIdSchoolEducations500,
  GetApiV1PersonIdSchoolEducationsPathParams,
  GetApiV1PersonIdSchoolEducationsQueryResponse,
} from "../../types/personStudentController/GetApiV1PersonIdSchoolEducations.ts";
import { schoolEducationDetailViewModelSchema } from "../schoolEducationDetailViewModelSchema.ts";

export const getApiV1PersonIdSchoolEducationsPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdSchoolEducationsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdSchoolEducations200Schema = z.array(
  z.lazy(() => schoolEducationDetailViewModelSchema),
) as unknown as ToZod<GetApiV1PersonIdSchoolEducations200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdSchoolEducations401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdSchoolEducations401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdSchoolEducations404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdSchoolEducations404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdSchoolEducations500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdSchoolEducations500>;

export const getApiV1PersonIdSchoolEducationsQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdSchoolEducations200Schema,
) as unknown as ToZod<GetApiV1PersonIdSchoolEducationsQueryResponse>;
